import { call, put, SagaReturnType, takeEvery } from 'redux-saga/effects';
import { schedularAnnouncementActions } from 'src/redux/actions/constant';
import therapistService from 'src/services/apiServices/therapist-scheduling/therapistService';
const { DELETE_ANNOUNCEMENT_REQUEST, DELETE_ANNOUNCEMENT_SUCCESS, DELETE_ANNOUNCEMENT_FAILURE } =
  schedularAnnouncementActions;

function* deleteAnnouncement(action: any): SagaReturnType<any> {
  try {
    const response = yield call(therapistService.deleteAnnouncement, action.payload);
    if (response?.status === 200) {
      yield put({ type: DELETE_ANNOUNCEMENT_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: DELETE_ANNOUNCEMENT_FAILURE, payload: error });
  }
}

function* deleteAnnouncementSaga() {
  yield takeEvery(DELETE_ANNOUNCEMENT_REQUEST, deleteAnnouncement);
}

export default deleteAnnouncementSaga;
